import { InjectionToken } from '@angular/core';
export const HURO_APP_ID = new InjectionToken<string>('HURO_APP_ID');
